import {
  USERREFERRAL_LOAD,
  USERREFERRAL_LOADED,
  USERREFERRAL_LOADERROR,
  USERREFERRAL_GENERATE,
  USERREFERRAL_GENERATED,
  USERREFERRAL_GENERATEERROR
} from "actions/referralActions.js";

const initialState = {};

export default function userReferral(state = initialState, action) {
  const {type, ...referralInfo} = action;
  switch (type) {
    case USERREFERRAL_LOAD:
      return {...state, loading: true};
    case USERREFERRAL_GENERATE:
      return {...state, generating: true};
    case USERREFERRAL_LOADERROR:
    case USERREFERRAL_GENERATEERROR:
      return {...state, error: action.message};
    case USERREFERRAL_LOADED:
      return {loading: false, loaded: true, ...referralInfo};
    case USERREFERRAL_GENERATED:
      return {loading: false, loaded: true, generating: false, ...referralInfo};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userReferralReducer.js